// src/features/wallet/WalletPage.tsx
import { GlassCard } from '../../app/components/ui/GlassCard';
import { EmptyState } from '../../app/components/foundation';

/**
 * No representative-compatible wallet endpoint has been provided yet,
 * so the balance/transactions sample data has been removed rather than
 * kept as a stand-in. Renders an explicit EmptyState instead of
 * fabricated balance/transaction data — swap this for real
 * WalletSummary/TransactionList wiring once a wallet API compatible
 * with representative authentication is confirmed.
 */
export function WalletPage() {
  return (
    <div className="flex flex-col gap-4 sm:gap-5">
      <div className="flex flex-col gap-1">
        <h1 className="text-lg font-semibold text-[var(--vania-colors-text-primary,#f5f6fa)]">
          کیف پول
        </h1>
        <p className="text-sm text-[var(--vania-colors-text-secondary,#a3aab8)]">
          موجودی و تراکنش‌های اخیر کیف پول شما.
        </p>
      </div>

      <GlassCard>
        <EmptyState message="اتصال کیف پول نماینده به Core Wallet هنوز فراهم نشده است؛ این بخش پس از آماده شدن API در دسترس خواهد بود." />
      </GlassCard>
    </div>
  );
}
